module.exports = __webpack_public_path__ + "static/media/banner-img-desktop@2x.27e958b1.png";